import { proxy } from 'valtio';

export const currentBoardTaskState: {
  status: 'idle' | 'busy';
  mode: 'none' | 'ai-generate';
} = proxy({
  status: 'idle',
  mode: 'none',
});
